module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/widget-calidad.11098ff1.svg";